(function() {
  "use strict";
  angular.module("marketPlace.watchdog", []);
})();
